import SimulcastErrorDlgContentComponent from './simulcastErrorDlgContent.component';

export const simulcastErrorDlgContentModule = {
	name: 'simulcastErrorDlgContentComponent',
};

export default angular
	.module(simulcastErrorDlgContentModule.name, [])
	.component('simulcastErrorDlgContent', new SimulcastErrorDlgContentComponent()).name;
